import { createApi } from '@reduxjs/toolkit/query/react';

import { generateBaseQuseryWithReAuth } from '@/store/baseQueryReauth';
import { Address } from '@/types/Address';
import { ResponseError } from '@/types/Error';

export const addressApi = createApi({
  reducerPath: 'user/account/addressApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: `user` }),
  tagTypes: ['GetAllAddresses', 'AddNewAddress', 'GetCustomerAddresses'],
  endpoints: builder => ({
    getAllAddresses: builder.query<{ addresses: Address[] }, string | number>({
      query: userId => ({ url: `/${userId}/address`, next: { tags: ['GetAllAddresses'] } }),
      transformResponse: (response: { data: { addresses: Address[] } }, meta, arg) => response.data,
      providesTags: ['GetAllAddresses'],
    }),
    addAddress: builder.mutation<{ address: Address }, { userId: string | number; address: Address }>({
      query: ({ userId, address }) => ({
        url: `/${userId}/address`,
        method: 'POST',
        body: JSON.stringify(address),
      }),
      transformResponse: (response: { data: { address: Address } }, meta, arg) => response.data,
      transformErrorResponse: response => response as ResponseError,
      invalidatesTags: ['GetAllAddresses', 'GetCustomerAddresses'],
    }),

    getCustomerAddresses: builder.query<{ firstName: string; lastName: string; addresses: Address[] }, void>({
      query: () => ({ url: `GetCustomerAddresses`, next: { tags: ['GetCustomerAddresses'] } }),
      transformResponse: (
        response: { data: { firstName: string; lastName: string; addresses: Address[] } },
        meta,
        arg
      ) => response.data,
      providesTags: ['GetCustomerAddresses'],
    }),
  }),
});

export const { useGetAllAddressesQuery, useAddAddressMutation, useGetCustomerAddressesQuery } = addressApi;
